import formSelect from "./formSelect.vue";

export default formSelect;
